import { render, staticRenderFns } from "./playVideoButton.vue?vue&type=template&id=952fdf16"
import script from "./playVideoButton.vue?vue&type=script&lang=js"
export * from "./playVideoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports